import React from 'react';
import { MessagesSquareIcon } from 'lucide-react';
import { CTAButton } from './CTAButton';
import { Reveal } from './Reveal';
export function FinalCTASection() {
  return <section className="bg-brand-blue px-4 py-24 text-center text-white" data-id="element-61" data-mp="3s269497cw5l0">
      <Reveal className="mx-auto max-w-3xl" data-id="element-62" data-mp="3s2xxayymj119">
        <div className="mx-auto flex h-12 w-12 items-center justify-center rounded-full bg-brand-teal/30 text-brand-orange" data-id="element-63" data-mp="wek5d5beyzs">
          <MessagesSquareIcon className="h-7 w-7" aria-hidden="true" data-id="element-64" data-mp="2zetlrwtdftqn" />
        </div>
        <h2 className="mt-5 text-4xl font-black md:text-5xl" data-id="element-65" data-mp="34bshukwliarh">
          Ready to Bring Spanish to Every Classroom?
        </h2>
        <p className="mx-auto mt-5 max-w-xl leading-relaxed text-white/75" data-id="element-66" data-mp="39a3rauizaj96">
          Save your prep time and teach every lesson with a clear plan, real
          speaking practice, and full confidence in the language.
        </p>
        <CTAButton className="mt-9 px-10 py-5 text-lg" data-id="element-67" data-mp="2gl6g1bd6pmpx">
          GET THE SPANISH READY PACK
        </CTAButton>
        <p className="mt-4 text-xs font-semibold text-white/70" data-id="element-68" data-mp="26ur9hdw3usxm">
          30-day money-back guarantee
        </p>
      </Reveal>
    </section>;
}